import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { focusStyle } from '../../styles/focusStyle';

const StyledLink = styled(Link)`
  font-size: 15px;
  line-height: ${({ theme }) => theme.lineHeights.xxs};
  color: ${({ theme }) => theme.colors.elvitaWebPurple};
  font-weight: 300;

  &:hover {
    text-decoration: underline;
  }

  &:active {
    color: ${({ theme }) => theme.colors.elvitaWebPink};
    text-decoration: none;
  }
  ${focusStyle}
`;

type AnchorProps = {
  href: string;
  children: React.ReactNode;
};

const Anchor: FC<AnchorProps> = ({ href, children }) => {
  return <StyledLink to={href}>{children}</StyledLink>;
};

export default Anchor;
